module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABSklEQVQoU5VSPS+DURg9T9v0Q4vERKw2QaLeio+l/8DUwSBEvdUIA4s/wcBQb1shJIZO/kEXUbwlQbpZiUmCVj+0PXLf9KXG3uXmnnvO85zz3CtordET+j1lrItgjkBdwQK4SJxXfdh/WJBSCwPG0xxyNnEG4shVwnFuU8rqcmqXvrofixAsNRyYv4vKk1iVK8hKEys3q3Jvd2zfQwccowOpqhdh0QxuA3g3Y5KY3GNPsR+VQkRqSjCcoTvwCu/1hnxoBuMAeiWU5JWziLCyoaV4SSKX12VLCSaS3BFg2tRlStlrBJAVLckLU5dZRQgaHHE38ZaLy7OVIcHBmgN9tzF5VGfF/SewfQcNdn37IPZkbNwStFuaOWR3rYE0gAGLRLx81REtrEnxz1Jb6FCKyyQ+TV0yLQsRAp68Lqe/oTseq6rU0cN1+jV+AAwGu528KAcOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/mood.png
// module id = AWAv
// module chunks = 1